import { Box, Heading, ListItem, OrderedList, Text } from "@chakra-ui/react";
import styles from "./terms.module.css";

export default function Terms() {
  return (
    <Box className={styles.faq}>
      <Box className={styles.faq1}>
        <Heading
          as="h1"
          size="4xl"
          fontSize={51.98102000000001}
          margin="0.67em 0"
        >
          Tripvillas User Agreement
        </Heading>
        <Text margin="0 0 10px ">Tripvillas.COM,</Text>
        <Text margin="0 0 10px ">Terms and Conditions of Use,</Text>
        <Text margin="0 0 10px ">
          By using or accessing Tripvillas.com (individually, the "Site"), you
          acknowledge that you agree to and are subject to the following terms
          and conditions (the "Terms"). If you do not fully agree to these
          Terms, you may not access or otherwise use the Site. You should read
          through all the Terms carefully. The Terms constitute a legally
          binding agreement between you and Homely Stays Pte. Ltd., the owner of
          Tripvillas.com ("Tripvillas", "we", "us" or "our").
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          The Site Is A Venue
        </Heading>
        <Text margin="0 0 10px ">
          PLEASE BE ADVISED THAT WE ARE NOT A PARTY TO ANY RENTAL TRANSACTION.
          We do not own nor can we contract for any vacation rental property
          listed on the Site. Instead, the Site acts as a venue to allow a
          member of our Site (each, a " member") to offer for rent, or rent, in
          a variety of pricing formats, a specific vacation rental property to
          potential renters (each, a "traveler " and, collectively with a
          member, the " users"). We are not involved in the actual transaction
          between travelers and members even though we may from time to time
          provide tools, such as direct booking, that enable a traveler to enter
          into a transaction to lease a specific property directly from the
          member of that property. As a result, the quality, safety or legality
          of the properties advertised, the truth or accuracy of the listings
          (including the content thereof or any property or guest book review),
          the ability of members to rent vacation property or the ability of
          travelers to pay for vacation rental properties are solely the
          responsibility of each user.
        </Text>
        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Personal Use.
        </Heading>
        <Text margin="0 0 10px ">
          Although we do charge a fee to members to advertise their vacation
          rental properties on the Site, we do not charge travelers to access
          the Site and research listings. Accordingly, we grant users a limited,
          revocable, non-exclusive license to access the Site to, as applicable,
          advertise vacation rental properties and/or research, view or make
          legitimate inquiries to members regarding their interest in particular
          vacation rental properties for their personal use, all in accordance
          with these Terms. Any other use of the Site is expressly prohibited.
          Importantly, this license does not include any right of collection,
          aggregation, copying, duplication, display or derivative use of the
          Site nor any right of use of data mining, robots, spiders or similar
          data gathering and extraction tools without our prior written
          permission; provided, however, that a limited exception from the
          foregoing exclusion is provided to general purpose internet search
          engines and non-commercial public archives that use tools to gather
          information for the sole purpose of displaying hyperlinks to the Site,
          provided they each do so from a stable IP address or range of IP
          addresses using an easily identifiable agent and comply with our
          robots.txt file. "General purpose internet search engine" does not
          include a website or search engine or other service that provide
          classified listings or property rental advertisements, or any subset
          of the same, or which is in the business of providing vacation
          property rental services.
        </Text>
        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Proprietary Rights and Downloading of Information From the Site.
        </Heading>
        <Text margin="0 0 10px ">
          The Site is protected by copyright as a collective work and/or
          compilation, pursuant to U.S. and Singapore copyright laws,
          international conventions, and other copyright laws. The text, files,
          images, photos, maps and other materials on the Site (collectively,
          the "content") are only for your personal use. All content on the
          Site, and the Site itself, is protected by copyright and database
          rights, and you will abide by any and all additional copyright
          notices, information, or restrictions contained in or relating to any
          content on the Site. Copying or storing of any content for other than
          for your personal, noncommercial use is expressly prohibited without
          the prior written permission from us or the applicable copyright
          holder. As part of the rental inquiry process, for your own personal,
          noncommercial use and not for further distribution, you may download,
          display, and/or print one (1) copy of any portion of the Site. You may
          not modify the same, and you must reproduce our copyright notice in
          the form "Â© 2008 - 2012 - Present Tripvillas.com (Homely Stays Pte.
          Ltd.) - All Rights Reserved", as displayed on the relevant portion(s)
          of the Site that you desire to download, display or print.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Unauthorized Use.
        </Heading>
        <Text margin="0 0 10px ">
          Unless otherwise provided within these Terms, or unless otherwise
          applicable law requires us to allow you to do so, you may not do any
          of the following without our prior written consent:
        </Text>
        <OrderedList>
          <ListItem>
            Copy, reproduce, upload, post, display, republish, distribute, or
            transmit any part of the content in any form whatsoever;
          </ListItem>
          <ListItem>
            Reproduce any portion of the Site on your website or otherwise,
            using any device including, but not limited to, use of a frame or
            border environment around the Site, or other framing technique to
            enclose any portion or aspect of the Site, or mirror or replicate
            any portion of the Site;
          </ListItem>
          <ListItem>
            Modify, translate into any language or computer language, or create
            derivative works from, any content or any part of this Site;
          </ListItem>
          <ListItem>Reverse engineer any part of this Site;</ListItem>
          <ListItem>
            Sell, offer for sale, transfer, or license any portion of the Site
            in any form to any third parties;
          </ListItem>
          <ListItem>
            Sell, offer for sale, transfer, or license any portion of the Site
            in any form to any third parties;
          </ListItem>
          <ListItem>
            Use the Site other than to advertise and/or research vacation
            rentals and to make legitimate inquiries to our members;
          </ListItem>
          <ListItem>
            Use the Site to make any false, fraudulent or speculative
            reservation, or any reservation in anticipation of demand;
          </ListItem>
          <ListItem>
            Post or transmit any unlawful, threatening, abusive, libelous,
            defamatory, obscene, vulgar, indecent, inflammatory, sexually
            explicit, pornographic or profane material or any material that
            could constitute or encourage conduct that would be considered a
            criminal offense, give rise to civil liability, or otherwise violate
            any law or for any other purpose that is unlawful or prohibited by
            these Terms;
          </ListItem>
          <ListItem>
            Post or transmit any information that constitutes or contains false
            or misleading indications of origin or statements of fact;
          </ListItem>
          <ListItem>
            Use or access the Site in any way that, in our sole discretion,
            adversely affects the performance or function of the Site, or any
            other computer systems or networks used by us or the Site, or
            infringes on our copyright or any copyright of our members;
          </ListItem>
          <ListItem>
            Violate, plagiarize or infringe the rights of third parties
            including, without limitation, copyright, trademark, patent, rights
            of publicity or privacy or any other proprietary rights;
          </ListItem>
          <ListItem>
            Upload or transmit to the Site or use any device, software or
            routine that contains viruses, Trojan horses, worms, time bombs, or
            other computer programming routines that may damage, interfere or
            attempt to interfere with, or intercept, the normal operation of the
            Site, or appropriate the Site or any system, or take any action that
            imposes an unreasonable load on our computer equipment, or that
            infringes upon the rights of any third party; or
          </ListItem>
          <ListItem>
            Disguise the origin of any information or inquiry transmitted
            through the Site.
          </ListItem>
        </OrderedList>
        <Text margin="0 0 10px ">
          If you are aware of or experience any content, activity or
          communication through or in connection with the Site that appears to
          be in violation of the above, or in violation of any other provision
          of these Terms, we ask that you please inform us of any such violation
          by sending an email to legal@Tripvillas.com.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Changes to Site.{" "}
        </Heading>
        <Text margin="0 0 10px ">
          We may change, suspend or discontinue any aspect of the Site at any
          time, including the availability of any Site features, database, or
          content. We may also impose limits on certain features or services or
          restrict your access to parts or all of the Site without notice or
          liability.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Your E-mail Address and Our Privacy Policy.
        </Heading>
        <Text margin="0 0 10px ">
          When you use the site to send an inquiry to a member, you agree to
          allow the Site and its affiliated websites to add your e-mail address
          to our database of users. You may receive one or more promotional
          e-mails from either the Site or its affiliated websites. You are
          welcome to opt not to receive such promotional e-mails from the Site
          or its affiliates websites at any time. Please review our Privacy
          Policy for more information regarding our information collection
          practices and safeguards, and how to opt not to receive such emails.
          Your use of the Site signifies your acknowledgement of and agreement
          with our Privacy Policy.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Data Transmittal
        </Heading>
        <Text margin="0 0 10px ">
          Each user acknowledges and agrees that, regardless of such user's
          physical location, we may store and process any data transmitted to
          the Site from such user at locations both within and outside of the
          Singapore.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Identity Verification.
        </Heading>
        <Text margin="0 0 10px ">
          User verification on the Internet is difficult and we cannot and do
          not confirm each user's purported identity. We encourage you to
          communicate directly with a traveler or member through the tools
          available on the Site. You agree to (i) keep your password and online
          ID secure and strictly confidential, providing it only to authorized
          users of your account, (ii) instruct each person to whom you give your
          online ID and password that he or she is not to disclose it to any
          unauthorized person, (iii) notify us immediately and select a new
          online ID and password if you believe your password may have become
          known to an unauthorized person, and (iv) notify us immediately if you
          are contacted by anyone requesting your online ID and password. When
          you give someone your online ID and online password, you are
          authorizing that person to access and use your account, and you are
          responsible for any and all transactions that person performs while
          using your account, even those transactions that are fraudulent or
          that you did not intend or want performed.
        </Text>
        <Text margin="0 0 10px ">
          EACH USER ACKNOWLEDGES AND AGREES THAT: (X) NEITHER THE SITE NOR ANY
          OF ITS AFFILIATES WILL HAVE ANY LIABILITY TO ANY USER FOR ANY
          UNAUTHORIZED TRANSACTION MADE USING ANY USER'S PASSWORD THAT OCCURS
          BEFORE SUCH USER HAS NOTIFIED US OF POSSIBLE UNAUTHORIZED USE OF SUCH
          PASSWORD AND WE HAVE HAD A REASONABLE OPPORTUNITY TO ACT ON THAT
          NOTICE; AND (Y) THE UNAUTHORIZED USE OF YOUR ONLINE ID AND PASSWORD
          COULD CAUSE YOU TO INCUR LIABILITY TO BOTH THE SITE AND OTHER USERS.
          Further, we may suspend or cancel your listing at any time even
          without receiving notice from you if we suspect that your password is
          being used in an unauthorized or fraudulent manner.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Limitations of Use of Other User's Information; No Spam.
        </Heading>
        <Text margin="0 0 10px ">
          You agree that, with respect to other users' personal information that
          you obtain through the Site or through any Site-related communication
          or any Site-facilitated transaction, we have granted to you a license
          to use such information only for: (a) any Site-related communications
          that are not unsolicited commercial messages, (b) using services
          offered through the Site, (c) facilitating a financial transaction
          between you and the other user (such as an on-line booking or charging
          a personal credit card) and (d) any other purpose that a user
          expressly agrees to after you tell them the purpose you would like to
          use it for. In all cases, you must give users an opportunity to remove
          themselves from your address book or database and a chance to review
          what information you have collected about them. In addition, under no
          circumstances, except as defined in this provision, can you disclose
          personal information about another user to any third party without
          both our consent and the consent of the other user. You agree that
          other users may use your personal information to communicate with you
          in accordance with this provision. Further, you agree that you will
          protect other users' personal information with the same degree of care
          that you protect your own confidential information, and you assume all
          liability for the misuse, loss, or unauthorized transfer of such
          information. We do not tolerate spam. Therefore, without limiting the
          foregoing, you are not licensed to add a Site user, even a user who
          has rented a vacation property from you or to you, to your mailing
          list (email or physical mail) without the user's express consent. Any
          unsolicited or commercial emails to any of the users registered on the
          website will be considered a violation of the terms of use and you
          agree to pay a non-negotiable damage fee of USD 500 per instance per
          email sent to users of the website.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Use of Email Tools.
        </Heading>
        <Text margin="0 0 10px ">
          You may not use the "Email This Item to a Friend" service or other
          email services that we may offer to send spam or otherwise send
          content that would violate these Terms
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          SMS and Email Alerts.
        </Heading>
        <Text margin="0 0 10px ">
          You authorise Tripvillas and it's affiliates to send you Email and SMS
          alerts, automated phone calls to inform you about new features,
          promotions and any alerts related to your account. You explicitly
          grant permission for such alerts, calls, SMSes.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Responsibility for user-contributed content.
        </Heading>
        <Text margin="0 0 10px ">
          We have no duty to pre-screen content posted on the Site by members,
          travelers or other users (including, without limitation, reviews of or
          guest book entries for any particular rental property), (collectively,
          "user-contributed content"), and we are not responsible for
          user-contributed content. We do, however, reserve the right to decline
          to permit the posting on the Site of, or to remove from, any
          user-contributed content that fails to meet our content requirements.
          We may also remove user-contributed content if it is brought to our
          attention, such as by notice given to us by a user under Clause 4 or
          17 of these Terms or by a third party, that Clause 4 of these Terms,
          or any other requirements governing the posting of such content,
          has/have been apparently breached in respect of that user-contributed
          content. All property listings on the Site are submitted by the member
          and are the responsibility of the member, and we specifically disclaim
          any and all liability arising from the alleged accuracy of the
          listings, property reviews, guest book entries, or any alleged
          breaches of contract on a member's part. Members are solely
          responsible for keeping their property information up to date on the
          Site, including, but not limited to any and all representations about
          any property, its amenities, location, and its availability for a
          specific date or range of dates. We do not represent or warrant that
          any of the copy, content, property reviews, guest book entries,
          property location, suitability, pricing or availability information
          published on the Site is accurate or up-to-date even in the case where
          prospective travelers have searched for specific special offers,
          dates, or types of properties. Members are solely responsible for
          ensuring the accuracy of any property descriptions. However, we
          reserve the right at all times to disclose any information as
          permitted by prevailing law to satisfy any law, regulation or
          government request.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Limitation of Liability.
        </Heading>
        <Text margin="0 0 10px ">
          12.1. IN NO EVENT WILL THE SITE, TRIPVILLAS.COM, OUR PARENT (HOMELY
          STAYS PTE. LTD.), SUBSIDIARIES, AFFILIATES, OFFICERS, DIRECTORS AND/OR
          EMPLOYEES (COLLECTIVELY, THE "TRIPVILLAS GROUP") BE LIABLE FOR ANY
          LOST PROFITS OR ANY INDIRECT, CONSEQUENTIAL, SPECIAL, INCIDENTAL, OR
          PUNITIVE DAMAGES ARISING OUT OF, BASED ON, OR RESULTING FROM OUR SITE,
          THESE TERMS, YOUR USE OF THE SITE AND/OR ANY TRANSACTION BETWEEN
          USERS, EVEN IF WE HAVE BEEN ADVISED OF THE POSSIBLITY OF SUCH DAMAGES.
          THESE LIMITATIONS AND EXCLUSIONS APPLY WITHOUT REGARD TO WHETHER THE
          DAMAGES ARISE FROM (1) BREACH OF CONTRACT, (2) BREACH OF WARRANTY, (3)
          STRICT LIABILITY, (4) TORT, (5) NEGLIGENCE, OR (6) ANY OTHER CAUSE OF
          ACTION, TO THE MAXIMUM EXTENT SUCH EXCLUSION AND LIMITATIONS ARE NOT
          PROHIBITED BY APPLICABLE LAW. IF YOU ARE DISSATISFIED WITH THE SITE,
          YOU DO NOT AGREE WITH ANY PART OF THIS AGREEMENT, OR HAVE ANY OTHER
          DISPUTE OR CLAIM WITH OR AGAINST US, ANOTHER USER OR THE SITE WITH
          RESPECT TO THESE TERMS OR THE SITE, THEN YOUR SOLE AND EXCLUSIVE
          REMEDY AGAINST US IS TO DISCONTINUE USING THE SITE. IN ALL EVENTS, OUR
          LIABILITY, AND THE LIABILITY OF ANY MEMBER OF THE TRIPVILLAS GROUP, TO
          YOU OR ANY THIRD PARTY IN ANY CIRCUMSTANCE ARISING OUT OF OR IN
          CONNECTION WITH THE SITE IS LIMITED TO THE GREATER OF (A) THE AMOUNT
          OF FEES YOU PAY TO US IN THE SIX MONTHS PRIOR TO THE ACTION GIVING
          RISE TO LIABILITY, AND (B) $100.00 IN THE AGGREGATE.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Disclaimer.
        </Heading>
        <Text margin="0 0 10px ">
          THE SITE, INCLUDING ALL CONTENT, SOFTWARE, FUNCTIONS, MATERIALS AND
          INFORMATION MADE AVAILABLE ON OR ACCESSED THROUGH THE SITE, IS
          PROVIDED "AS IS." TO THE FULLEST EXTENT PERMISSIBLE BY LAW, WE MAKE NO
          REPRESENTATIONS OR WARRANTIES OF ANY KIND WHATSOEVER FOR THE CONTENT
          ON THE SITE OR THE MATERIALS, INFORMATION AND FUNCTIONS MADE
          ACCESSIBLE BY THE SOFTWARE USED ON OR ACCESSED THROUGH THE SITE, FOR
          ANY PRODUCTS OR SERVICES OR HYPERTEXT LINKS TO THIRD PARTIES OR FOR
          ANY BREACH OF SECURITY ASSOCIATED WITH THE TRANSMISSION OF SENSITIVE
          INFORMATION THROUGH THE SITE OR ANY LINKED SITE. FURTHER, WE EXPRESSLY
          DISCLAIM ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, WITHOUT
          LIMITATION, NON-INFRINGEMENT, MERCHANTABILITY, FITNESS FOR A
          PARTICULAR PURPOSE OR ACCURACY. WE DO NOT WARRANT THAT THE FUNCTIONS
          CONTAINED IN THE SITE OR ANY MATERIALS OR CONTENT CONTAINED THEREIN
          WILL BE UNINTERRUPTED OR ERROR FREE, THAT DEFECTS WILL BE CORRECTED,
          OR THAT THE SITE OR THE SERVER THAT MAKES IT AVAILABLE IS FREE OF
          VIRUSES OR OTHER HARMFUL COMPONENTS. YOU ACKNOWLEDGE THAT ANY
          TRANSMISSION TO AND FROM THIS SITE IS NOT CONFIDENTIAL AND YOUR
          COMMUNICATIONS MAY BE READ OR INTERCEPTED BY OTHERS. YOU ACKNOWLEDGE
          THAT BY SUBMITTING COMMUNICATIONS TO US AND BY POSTING INFORMATION ON
          THE SITE, NO CONFIDENTIAL, FIDUCIARY, CONTRACTUALLY IMPLIED OR OTHER
          RELATIONSHIP IS CREATED BETWEEN YOU AND US OTHER THAN PURSUANT TO
          THESE TERMS.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Release.
        </Heading>
        <Text margin="0 0 10px ">
          IN THE EVENT THAT YOU HAVE A DISPUTE WITH ONE OR MORE OTHER USERS OF
          THE SITE (INCLUDING, WITHOUT LIMITATION, ANY DISPUTE BETWEEN USERS
          REGARDING ANY TRANSACTION OR USER-CONTRIBUTED CONTENT), YOU HEREBY
          AGREE TO RELEASE, REMISE AND FOREVER DISCHARGE THE SITE AND ANY MEMBER
          OF THE TRIPVILLAS GROUP, EACH OF THEIR RESPECTIVE AGENTS, DIRECTORS,
          OFFICERS, EMPLOYEES, AND ALL OTHER RELATED PERSONS OR ENTITIES FROM
          ANY AND ALL MANNER OF RIGHTS, CLAIMS, COMPLAINTS, DEMANDS, CAUSES OF
          ACTION, PROCEEDINGS, LIABILITIES, OBLIGATIONS, LEGAL FEES, COSTS, AND
          DISBURSEMENTS OF ANY NATURE WHATSOEVER, WHETHER KNOWN OR UNKNOWN,
          WHICH NOW OR HEREAFTER ARISE FROM, RELATE TO, OR ARE CONNECTED WITH
          SUCH DISPUTE AND/OR YOUR USE OF THE SITE.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Indemnity.
        </Heading>
        <Text margin="0 0 10px ">
          YOU HEREBY AGREE TO INDEMNIFY, DEFEND AND HOLD THE SITE AND ANY MEMBER
          OF THE TRIPVILLAS GROUP (COLLECTIVELY, THE "INDEMNIFIED PARTIES")
          HARMLESS FROM AND AGAINST ANY AND ALL LIABILITY AND COSTS INCURRED BY
          THE INDEMNIFIED PARTIES IN CONNECTION WITH ANY CLAIM ARISING OUT OF
          YOUR USE OF THE SITE (INCLUDING, WITHOUT LIMITATION, ANY DISPUTE
          BETWEEN USERS REGARDING ANY TRANSACTION OR ANY OF YOUR
          USER-CONTRIBUTED CONTENT), ANY CONTENT POSTED BY YOU OR OTHER USERS OF
          YOUR ACCOUNT TO THE SITE OR ANY BREACH BY YOU OF THESE TERMS OR THE
          REPRESENTATIONS, WARRANTIES AND COVENANTS MADE BY YOU HEREIN,
          INCLUDING, WITHOUT LIMITATION, ATTORNEYS' FEES AND COSTS. YOU SHALL
          COOPERATE AS FULLY AS REASONABLY REQUIRED IN THE DEFENSE OF ANY CLAIM.
          WE RESERVE THE RIGHT, AT OUR OWN EXPENSE, TO ASSUME THE EXCLUSIVE
          DEFENSE AND CONTROL OF ANY MATTER OTHERWISE SUBJECT TO INDEMNIFICATION
          BY YOU AND YOU SHALL NOT IN ANY EVENT SETTLE ANY MATTER WITHOUT OUR
          WRITTEN CONSENT.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Choice of Law and Forum.
        </Heading>
        <Text margin="0 0 10px ">
          ANY AND ALL SERVICES AND RIGHTS OF USE HEREUNDER ARE PERFORMABLE
          AND/OR SOLD IN THE REPUBLIC OF SINGAPORE, AND YOU IRREVOCABLY AGREE
          THAT ANY CAUSE OF ACTION YOU MAY SUBMIT IN CONNECTION WITH YOUR USE OF
          THE SITE OR PURSUANT TO THESE TERMS WILL BE FILED IN SINGAPORE WHICH
          WILL BE THE VENUE OF ANY LEGAL DISPUTE. YOU ALSO AGREE THAT ANY
          DISPUTE BETWEEN YOU AND US WILL BE GOVERNED BY THE LAWS OF SINGAPORE.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Notification of Claims of Infringement.
        </Heading>
        <Text margin="0 0 10px ">
          If you believe that your work has been copied in a way that
          constitutes copyright infringement, or your intellectual property
          rights have been otherwise violated, please notify our agent for
          claims of copyright or other intellectual property infringement at:
          legal@Tripvillas.com or Tripvillas.com, 261 Waterloo Street, #03-32,
          Singapore 180261. Please include the following in your notice: (a)
          identify with specific detail the material on the Site that you claim
          is infringing; (b) a statement by you that you have a good faith
          belief that the disputed use is not authorized by the copyright owner,
          its agent or the law; (c) a statement by you declaring under penalty
          of perjury that (i) the above information in your notice is accurate,
          and (ii) you are the owner of the copyright interest involved or that
          you are authorized to act on behalf of that owner; (d) your physical
          address, telephone number and email address; and (e) your physical or
          electronic signature. We will thereafter remove the allegedly
          infringing content, subject to the procedures outlined in the Digital
          Millennium Copyright Act (DMCA). If you see or experience any
          user-contributed or other content, activity or communication through
          or in connection with the Site, that appears to infringe any
          requirement of these Terms, we would like you to inform us at
          legal@Tripvillas.com. We rely upon users to notify us of infringing
          content, activity and communications.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          No Agency.
        </Heading>
        <Text margin="0 0 10px ">
          Our relationship is that of independent contractors, and no agency,
          partnership, joint venture, employee-employer or franchiser-franchisee
          relations is intended or created by these Terms or your use of the
          Site.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Notices.
        </Heading>
        <Text margin="0 0 10px ">
          Except as explicitly stated otherwise, any notices shall be given (in
          the case of you contacting us) by email to legal@Tripvillas.com or by
          postal mail to: Tripvillas.com, Attn: Legal Department 261 Waterloo
          Street, #03-32, Singapore 180261 or, when we need to send you notice,
          to the email address you provide to the Site during the registration
          process (in your case, and as applicable). Notice shall be deemed
          given upon receipt or 24 hours after email is sent, unless the sending
          party is notified that the email address is invalid. Alternatively, we
          may give you notice by certified mail, postage prepaid and return
          receipt requested, to any address provided to us during the
          registration process (as applicable). In such case, notice shall be
          deemed given three days after the date of mailing.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Amendments.
        </Heading>
        <Text margin="0 0 10px ">
          We reserve the right, in our sole discretion, to change, modify, add
          or remove any portion of these Terms, in whole or in part, at any
          time. Notification of changes to these Terms will be posted on the
          Site and will be effective immediately thereafter. Your continued use
          of the Site following the posting of any such change, modification or
          amendment will constitute your acceptance thereof.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Links to Third-Party Sites.
        </Heading>
        <Text margin="0 0 10px ">
          This Site may contain links and pointers to other Internet sites,
          resources, and sponsors of the Site. Links to and from the Site to
          other third-party sites, maintained by third parties, do not
          constitute an endorsement by us of any third-party sites or the
          contents thereof.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Your Record of These Terms.
        </Heading>
        <Text margin="0 0 10px ">
          We do not separately file the Terms entered into by each user of the
          Site. Please make a copy of these Terms for your records by printing
          and/or saving a downloaded copy of the Terms on your personal
          computer.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Miscellaneous.
        </Heading>
        <Text margin="0 0 10px ">
          These terms constitute the entire agreement between us and you with
          respect to your use of the Site. We may immediately terminate any
          user's access to or use of the Site due to such user's breach of these
          Terms or other unauthorized use of the Site. Any cause of action you
          may have hereunder or with respect to your use of the Site must be
          commenced within one (1) year after the claim or cause of action
          arises. Our failure to exercise or enforce any right or provision of
          these Terms shall not constitute a waiver of any such right or
          provision. If for any reason a court of competent jurisdiction finds
          any provision of these Terms, or portion thereof, to be unenforceable,
          that provision shall be enforced to the maximum extent permissible so
          as to effect the intent of these Terms, and the remainder of these
          Terms shall continue in full force and effect. Additional Terms and
          Conditions Applicable to Our Members
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Member Eligibility; Accuracy of Information.
        </Heading>
        <Text margin="0 0 10px ">
          Our services may only be used by members who can form legally binding
          contracts under applicable law. If you are registering as a business
          entity, you represent that you have the authority to bind the entity
          to this Agreement. Each member further represents and covenants that
          any information submitted to the Site during such member's
          registration with the Site shall be true and correct. Member further
          agrees to provide notice to the Site by submitting their request
          through our help form regarding any updates to any such contact
          information previously submitted by member to the Site. Each member
          further represents and covenants that: (i) it owns and/or has all
          necessary rights and authority to offer for rent and to rent the
          property listed by such member; (ii) it will not wrongfully withhold a
          rental deposit in breach of the underlying rental agreement; (iii)
          that it will accurately describe the subject rental property and will
          not fail to disclose a material defect in a rental property; (iv) that
          it will not wrongfully deny access to the listed property; and (v)
          that it will not fail to provide a refund when due in accordance with
          the underlying rental agreement. Upon our request, each member agrees
          to promptly provide to us such proof of personal identification, proof
          that the condition, location, or amenities associated with the
          property are accurately described in the listing, proof of ownership
          of the property listed on the Site, and/or proof of authority to list
          the property as we may request.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Content, Layout and Copy.
        </Heading>
        <Text margin="0 0 10px ">
          We reserve the right to determine in our sole discretion the final
          design, layout and functionality of our Site, which is subject to
          change from time to time without notice. We reserve the right, in our
          sole discretion, to review and edit copy or amend the content, layouts
          or photographs supplied by any member. All content and copy edits
          submitted by members are subject to review and approval by us in our
          sole discretion. Notwithstanding our right to edit and amend the
          content, copy and photographs, we do not accept and we shall not have
          any liability for any loss or damage resulting from the design or
          positioning of the copy, properties, content and/or photographs or any
          change made to any content, photograph or copy submitted by any member
          or edited or amended by us.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Photographs.
        </Heading>
        <Text margin="0 0 10px ">
          All printed (paper based) photographs submitted by a member will be
          discarded after we have scanned the same into our electronic database.
          Regretfully, we are unable to return such photographs to you or retain
          paper copies in our files. We will use reasonable efforts to reproduce
          faithfully any photograph submitted, but we are not responsible for
          any loss or damage or harm otherwise resulting from any defect in this
          regard. By submitting a photograph either electronically through the
          Site or by mailing a paper photograph to our offices, the member
          represents and warrants that (a) (i) it holds all intellectual
          property rights with respect to each submitted photograph, or (ii) it
          has secured from the copyright holder all rights necessary for the
          photograph to be used in an online advertisement, (b) that any people
          in the photograph have given permission for their likeness to be
          displayed in an online advertisement, (c) that the photograph
          accurately and fairly represents the subject of the photograph and has
          not been altered in any manner that would mislead a viewer of that
          photograph, and (d) that it will indemnify and hold harmless the Site
          and any member of the Tripvillas Group from any cause of action
          arising from any misrepresentation with respect to any and all the
          photographs so submitted.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Copyright Grant.
        </Heading>
        <Text margin="0 0 10px ">
          If you are a member, by accepting these Terms and by paying for and
          posting a listing on the Site, you grant to us and our affiliates a
          perpetual, worldwide, irrevocable, unrestricted, non-exclusive,
          royalty-free and fully paid-up license to use, copy, license,
          sublicense (through multiple tiers), adapt, distribute, display,
          publicly perform, reproduce, transmit, modify, edit and otherwise
          exploit the copy, the photographs and the likenesses (if any) of any
          content you post on the Site or the websites of our affiliates, and
          you grant the Site and its holding company, TripVillas , the ability
          to copyright and protect the images, copy, and content available via
          your listing from the unauthorized use by unaffiliated third parties
          who may, from time to time, attempt to pirate such information via
          electronic or other means. We need these rights to host and display
          your listing. You further agree to assist us--at our expense and
          control--to protect such copyrighted material from unauthorized
          redistribution. We are not responsible for any infringement or
          violation of laws resulting from content supplied by any member and
          each member will indemnify and hold harmless the Site and any member
          of the Tripvillas Group against any action brought for breach of
          copyright or other rights from the use of such content supplied by
          such member. Each member hereby waives and releases all rights to any
          claim against us for any alleged or actual infringement of any
          proprietary rights, rights of privacy and publicity, moral rights and
          rights of attribution in connection with any user-contributed content
          posted or provided to us by such member. Each member agrees that we
          may reproduce in whole or in part any photographic material supplied
          by such member in the promotion of either such member's property or
          the promotion of the Site. It is the member's responsibility to obtain
          reproduction permission for all photographic and other material used
          in their advertisements. The member warrants that he is the owner of
          the copyright in such material or is authorized by the owner thereof
          to grant to us the rights therein contained.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Hypertext Links.
        </Heading>
        <Text margin="0 0 10px ">
          We reserve the right to refuse hypertext links to, or addresses of,
          other web sites from members' pages, and to remove links or web
          addresses without notice at our sole discretion. Further, we reserve
          the right to charge for hypertext links at any time.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Guest Books/Property Reviews.
        </Heading>
        <Text margin="0 0 10px ">
          Any entries in the guest book or property review section of any
          member's listing must be genuine comments from guests who have stayed
          at the property advertised. The e-mail address(es) of the guest(s)
          whose comments are given must be supplied by a member to us upon our
          request.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Substitution of Properties.
        </Heading>
        <Text margin="0 0 10px ">
          Each advertisement may only relate to a specific property. The
          property in an advertisement may not be substituted by another
          property. If a member submits changes to an existing listing that, if
          approved, would substantially alter the listing to make it that of
          another property, then we have the right to terminate the listing and
          may choose, in our sole discretion, to retain any fees associated with
          the term of the previously existing listing as compensation for the
          violation of this condition.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Advertising More than One Property on One Advertisement.
        </Heading>
        <Text margin="0 0 10px ">
          Each advertisement on the Site displays an individual and uniquely
          identified property available for short-term vacation rental. The
          listing specifically cannot be a mere example of properties in a given
          area. Only one property can appear on each advertisement, unless it is
          a property with multiple rental units on the same site and additional
          advertising units are purchased. We reserve the right to amend the
          copy or remove any advertisement when more than one property is
          described in such advertisement, and may choose, in our sole
          discretion to retain any fees associated with the initial term of such
          non-conforming listing as compensation for the violation of this
          condition.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Unauthorized Payment Methods
        </Heading>
        <Text margin="0 0 10px ">
          No member may request any traveler to mail cash, or utilize any
          instant-cash wire transfer service such as Western Union or MoneyGram
          in payment for all or part of a property rental transaction. Any
          violation of this term or any other unacceptable payment methods that
          may be posted on the Site from time to time may result in the
          immediate removal of the non-conforming listing from the Site without
          notice to member and without refund.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Transfer of Listing
        </Heading>
        <Text margin="0 0 10px ">
          No listing may be transferred to another party, except that if a
          member sells the property that is listed, the member may transfer its
          listing to the new owner of the property that is listed. We may, at
          our discretion, charge a reasonable transfer fee.
        </Text>

        <Heading
          as="h5"
          size="sm"
          margin="0 0 10px "
          fontSize="18.2px"
          fontWeight={600}
        >
          Payment.
        </Heading>
        <Text margin="0 0 10px ">
          Payment for Power listings must be made in USD or Singapore Dollars
          paid either by major credit or debit card, or via SWIFT transfer.
        </Text>
      </Box>
    </Box>
  );
}
